import { EnvironmentService } from 'src/app/services/environment.service';
import { Directive, Input } from '@angular/core';
import { NG_VALIDATORS, Validator, ValidationErrors, AbstractControl } from '@angular/forms';
import { MIN_TOTAL_FEED_IN_POWER_FOR_CENTRAL_GRID_PROTECTION } from 'src/app/+grid-application-shared/constants/grid-application-constants';

@Directive({
  selector: '[appTotalPowerValid]',
  providers: [{ provide: NG_VALIDATORS, useExisting: TotalPowerValidDirective, multi: true }],
})
export class TotalPowerValidDirective implements Validator {
  @Input('appTotalPowerValid') compareType: 'EqualOrHigher' | 'LessThan' = 'LessThan';

  constructor(private environmentService: EnvironmentService) {}

  validate(control: AbstractControl): ValidationErrors | null {
    if (this.environmentService.skipTotalFeedInPowerValidation) return null;
    if (!control.value) return null;

    if (this.compareType === 'EqualOrHigher') {
      return Number.parseFloat(control.value) >= MIN_TOTAL_FEED_IN_POWER_FOR_CENTRAL_GRID_PROTECTION
        ? null
        : { notEqualOrHigherError: true };
    } else {
      return Number.parseFloat(control.value) < MIN_TOTAL_FEED_IN_POWER_FOR_CENTRAL_GRID_PROTECTION ? null : { notLessError: true };
    }
  }
}
